import React, { useState, useRef, useEffect } from 'react';

// ------------------------------------------------------------------
// آیکون‌های اختصاصی هر دوره (SVG سبک، رنگ از currentColor)
// ------------------------------------------------------------------
const CourseIcons = {
    // تیرآهن I شکل -> سازه فولادی
    steel: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 4h14M5 20h14M12 4v16" />
            <path d="M8 4v0M16 4v0" />
        </svg>
    ),
    // مقطع ستون بتنی با میلگرد
    concrete: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="4" width="16" height="16" rx="1.5" />
            <rect x="8" y="8" width="8" height="8" rx="0.5" strokeDasharray="2 2" />
            <circle cx="6.8" cy="6.8" r="0.6" fill="currentColor" />
            <circle cx="17.2" cy="6.8" r="0.6" fill="currentColor" />
            <circle cx="6.8" cy="17.2" r="0.6" fill="currentColor" />
            <circle cx="17.2" cy="17.2" r="0.6" fill="currentColor" />
        </svg>
    ),
    // دال و فونداسیون روی خاک
    safe: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 3v8M15 3v8" />
            <path d="M3 11h18v4H3z" />
            <path d="M3 19l2 2M8 19l2 2M13 19l2 2M18 19l2 2" />
        </svg>
    ),
    // ورق اتصال و پیچ‌ها
    idea: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="3" width="16" height="18" rx="1.5" />
            <circle cx="9" cy="8" r="1.3" />
            <circle cx="15" cy="8" r="1.3" />
            <circle cx="9" cy="16" r="1.3" />
            <circle cx="15" cy="16" r="1.3" />
            <path d="M12 3v18" strokeDasharray="1 2.5" />
        </svg>
    ),
    // پوسته منحنی / فرم آزاد -> راینو و گرس‌هاپر
    rhino: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 19c3-12 7-14 10-14s7 2 10 14" />
            <path d="M7 19c1.2-7 3-9 5-9s3.8 2 5 9" />
            <path d="M2 19h20" />
        </svg>
    ),
    // ایتانکس: ساختمان چندطبقه (ETABS)
    etabs: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 21V4h12v17M3 21h18" />
            <path d="M9 8h2M13 8h2M9 12h2M13 12h2M9 16h2M13 16h2" />
        </svg>
    ),
    // والیکا: دیوار آجری
    wall: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="5" width="18" height="14" rx="1" />
            <path d="M3 9.7h18M3 14.3h18M9 5v4.7M15 9.7v4.6M9 14.3V19" />
        </svg>
    ),
    // استراکتیکا: خرپای فضایی
    truss: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 19L12 5l9 14H3z" />
            <path d="M12 5v14M7.5 12l4.5 7 4.5-7M7.5 12h9" />
            <circle cx="12" cy="5" r="1" fill="currentColor" />
            <circle cx="3" cy="19" r="1" fill="currentColor" />
            <circle cx="21" cy="19" r="1" fill="currentColor" />
        </svg>
    ),
    // سایزمیکا: نمودار لرزه‌ای / هیسترزیس
    seismic: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 12h3l2-6 4 12 3-9 2 3h6" />
        </svg>
    ),
    // استاندارد ۲۸۰۰: طیف شتاب
    spectrum: (
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4v16h16" />
            <path d="M6 17c1-7 2-10 4-10s2.5 3 4.5 5 3 3 5.5 3" />
        </svg>
    ),
    chevron: (
        <svg viewBox="0 0 24 24" className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
        </svg>
    )
};

// ------------------------------------------------------------------
// آیکون بخش‌های اصلی منو (رنگ هر آیکون از TONES هر آیتم می‌آید)
// ------------------------------------------------------------------
const NAV_SVG = 'w-[18px] h-[18px]';
const NavIcons = {
    // خانه
    home: (
        <svg viewBox="0 0 24 24" className={NAV_SVG} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 11l9-8 9 8" />
            <path d="M5 10v10h14V10" />
            <path d="M10 20v-6h4v6" />
        </svg>
    ),
    // آموزش‌ها: کلاه فارغ‌التحصیلی
    learn: (
        <svg viewBox="0 0 24 24" className={NAV_SVG} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 9L12 4 2 9l10 5 10-5z" />
            <path d="M6 11.5V16c0 1.5 3 3 6 3s6-1.5 6-3v-4.5" />
        </svg>
    ),
    // برنامه‌های رایگان: هدیه
    free: (
        <svg viewBox="0 0 24 24" className={NAV_SVG} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="8" width="18" height="4" rx="1" />
            <path d="M5 12v9h14v-9" />
            <path d="M12 8v13" />
            <path d="M12 8c-1.5-4-6-3.5-5 0M12 8c1.5-4 6-3.5 5 0" />
        </svg>
    ),
    // محصولات: جعبه
    products: (
        <svg viewBox="0 0 24 24" className={NAV_SVG} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 8l-9-5-9 5v8l9 5 9-5V8z" />
            <path d="M3 8l9 5 9-5" />
            <path d="M12 13v8" />
        </svg>
    ),
    // تالار گفت‌و‌گو: حباب پیام
    forum: (
        <svg viewBox="0 0 24 24" className={NAV_SVG} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12a8 8 0 0 1-11.5 7.2L3 21l1.8-5.5A8 8 0 1 1 21 12z" />
            <circle cx="8.5" cy="12" r="0.8" fill="currentColor" />
            <circle cx="12" cy="12" r="0.8" fill="currentColor" />
            <circle cx="15.5" cy="12" r="0.8" fill="currentColor" />
        </svg>
    ),
    // اخبار: روزنامه
    news: (
        <svg viewBox="0 0 24 24" className={NAV_SVG} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 5h12v14H6a2 2 0 0 1-2-2V5z" />
            <path d="M16 9h4v8a2 2 0 0 1-2 2h-2" />
            <path d="M7 9h6M7 12h6M7 15h4" />
        </svg>
    ),
    // درباره ما: اطلاعات
    about: (
        <svg viewBox="0 0 24 24" className={NAV_SVG} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 11v5" />
            <circle cx="12" cy="7.8" r="0.9" fill="currentColor" />
        </svg>
    )
};

// آیکون رنگی با انیمیشن هنگام هاور (والد باید کلاس group داشته باشد)
const NavIcon = ({ name, tone }) => (
    <span
        className="inline-flex shrink-0 transition-transform duration-300 group-hover:scale-125 group-hover:-rotate-6"
        style={{ color: TONES[tone].a, filter: `drop-shadow(0 0 3px ${TONES[tone].a}66)` }}
    >
        {NavIcons[name]}
    </span>
);

// ------------------------------------------------------------------
// فهرست دوره‌ها؛ برای افزودن دوره‌ی جدید فقط یک آیتم به این آرایه اضافه کنید
// (کلاس‌های تیلویند کامل نوشته شده‌اند تا هنگام build حذف نشوند)
// ------------------------------------------------------------------
const COURSES = [
    {
        page: 'rhino-training',
        title: 'راینو + گرس‌هاپر',
        sub: 'سازه‌های خاص و خرپای فضایی',
        icon: 'rhino',
        isNew: true,
        wide: true,
        iconBox: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/30 group-hover:bg-cyan-500 group-hover:text-slate-900',
        hoverCard: 'hover:border-cyan-500/50 hover:bg-cyan-500/5',
        active: 'border-cyan-500/50 bg-cyan-500/5'
    },
    {
        page: 'etabs-training',
        title: 'ایتبس فولادی',
        sub: 'طراحی سازه فولادی',
        icon: 'steel',
        iconBox: 'bg-red-500/10 text-red-400 border-red-500/30 group-hover:bg-red-500 group-hover:text-white',
        hoverCard: 'hover:border-red-500/50 hover:bg-red-500/5',
        active: 'border-red-500/50 bg-red-500/5'
    },
    {
        page: 'etabs-concrete-training',
        title: 'ایتبس بتنی',
        sub: 'طراحی سازه بتن‌آرمه',
        icon: 'concrete',
        iconBox: 'bg-amber-500/10 text-amber-400 border-amber-500/30 group-hover:bg-amber-500 group-hover:text-slate-900',
        hoverCard: 'hover:border-amber-500/50 hover:bg-amber-500/5',
        active: 'border-amber-500/50 bg-amber-500/5'
    },
    {
        page: 'safe-training',
        title: 'سیف (SAFE)',
        sub: 'دال و فونداسیون',
        icon: 'safe',
        iconBox: 'bg-blue-500/10 text-blue-400 border-blue-500/30 group-hover:bg-blue-500 group-hover:text-white',
        hoverCard: 'hover:border-blue-500/50 hover:bg-blue-500/5',
        active: 'border-blue-500/50 bg-blue-500/5'
    },
    {
        page: 'IdeaStatica-training',
        title: 'آیدیا استاتیکا',
        sub: 'اتصالات فولادی (CBFEM)',
        icon: 'idea',
        iconBox: 'bg-purple-500/10 text-purple-400 border-purple-500/30 group-hover:bg-purple-500 group-hover:text-white',
        hoverCard: 'hover:border-purple-500/50 hover:bg-purple-500/5',
        active: 'border-purple-500/50 bg-purple-500/5'
    }
];

const COURSE_PAGES = COURSES.map(c => c.page);

// ------------------------------------------------------------------
// فهرست محصولات؛ page همان کلید PAGE_ROUTES در App.jsx است
// ------------------------------------------------------------------
const PRODUCTS = [
    {
        page: 'etanex',
        title: 'EtaNex (ایتانکس)',
        sub: 'اتوماسیون هوشمند مدل‌سازی و طراحی در ETABS',
        icon: 'etabs',
        wide: true,
        iconBox: 'bg-purple-500/10 text-purple-400 border-purple-500/30 group-hover:bg-purple-500 group-hover:text-white',
        hoverCard: 'hover:border-purple-500/50 hover:bg-purple-500/5',
        active: 'border-purple-500/50 bg-purple-500/5'
    },
    {
        page: 'betonica',
        title: 'BetoniCa (بتنیکا)',
        sub: 'طراحی اعضای بتن‌آرمه - مبحث ۹',
        icon: 'concrete',
        iconBox: 'bg-amber-500/10 text-amber-400 border-amber-500/30 group-hover:bg-amber-500 group-hover:text-slate-900',
        hoverCard: 'hover:border-amber-500/50 hover:bg-amber-500/5',
        active: 'border-amber-500/50 bg-amber-500/5'
    },
    {
        page: 'steelica',
        title: 'SteeliCa (استیلیکا)',
        sub: 'طراحی فولاد و اتصالات - مبحث ۱۰',
        icon: 'steel',
        iconBox: 'bg-red-500/10 text-red-400 border-red-500/30 group-hover:bg-red-500 group-hover:text-white',
        hoverCard: 'hover:border-red-500/50 hover:bg-red-500/5',
        active: 'border-red-500/50 bg-red-500/5'
    },
    {
        page: 'wallica',
        title: 'WalliCa (والیکا)',
        sub: 'وال‌پست و دیوارهای غیرسازه‌ای',
        icon: 'wall',
        iconBox: 'bg-teal-500/10 text-teal-400 border-teal-500/30 group-hover:bg-teal-500 group-hover:text-slate-900',
        hoverCard: 'hover:border-teal-500/50 hover:bg-teal-500/5',
        active: 'border-teal-500/50 bg-teal-500/5'
    },
    {
        page: 'structica',
        title: 'StructiCa (استراکتیکا)',
        sub: 'تحلیل خرپای فضایی در راینو',
        icon: 'truss',
        iconBox: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30 group-hover:bg-emerald-500 group-hover:text-slate-900',
        hoverCard: 'hover:border-emerald-500/50 hover:bg-emerald-500/5',
        active: 'border-emerald-500/50 bg-emerald-500/5'
    },
    {
        page: 'seismica',
        title: 'SeismiCa (سایزمیکا)',
        sub: 'نتایج هیسترزیس و انیماتور قاب',
        icon: 'seismic',
        iconBox: 'bg-pink-500/10 text-pink-400 border-pink-500/30 group-hover:bg-pink-500 group-hover:text-white',
        hoverCard: 'hover:border-pink-500/50 hover:bg-pink-500/5',
        active: 'border-pink-500/50 bg-pink-500/5'
    },
    {
        page: 'std2800',
        title: 'استاندارد ۲۸۰۰ - V5',
        sub: 'پریود، ضریب برش پایه و طیف',
        icon: 'spectrum',
        badge: 'رایگان',
        badgeCls: 'bg-emerald-500 text-slate-900',
        iconBox: 'bg-orange-500/10 text-orange-400 border-orange-500/30 group-hover:bg-orange-500 group-hover:text-slate-900',
        hoverCard: 'hover:border-orange-500/50 hover:bg-orange-500/5',
        active: 'border-orange-500/50 bg-orange-500/5'
    }
];

const PRODUCT_PAGES = PRODUCTS.map(c => c.page);

// تنظیمات دو منوی کشویی دسکتاپ
const MENUS = {
    courses: { items: COURSES, title: 'دوره‌های آموزشی رایگان', note: 'ویدیو + فایل تمرینی', footer: null },
    products: { items: PRODUCTS, title: 'محصولات ارکانی عمران', note: 'نرم‌افزارهای تخصصی مهندسی', footer: { label: 'مشاهده‌ی همه‌ی محصولات', page: 'home', section: 'products-section' } }
};

// میزان بیرون‌زدگی «شکم» خط زیر هدر، زیر آیتم هاورشده (پیکسل)
const BELLY_DEPTH = 20;

// رنگ گرادیانی مخصوص هر آیتم منو (a: شروع، b: میانه، c: پایان)
const TONES = {
    home:     { a: '#facc15', b: '#f59e0b', c: '#f97316' }, // طلایی
    courses:  { a: '#22d3ee', b: '#34d399', c: '#3b82f6' }, // فیروزه‌ای-سبز
    free:     { a: '#fb923c', b: '#f43f5e', c: '#e11d48' }, // نارنجی-سرخ
    products: { a: '#a78bfa', b: '#8b5cf6', c: '#d946ef' }, // بنفش
    forum:    { a: '#38bdf8', b: '#3b82f6', c: '#6366f1' }, // آبی
    news:     { a: '#bef264', b: '#84cc16', c: '#22c55e' }, // سبز لیمویی
    about:    { a: '#f1f5f9', b: '#cbd5e1', c: '#94a3b8' }  // نقره‌ای
};
const TONE_KEYS = Object.keys(TONES);

const HeaderNavigation = ({
    activePage,
    onNavigate,
    user,
    userProfile,
    onSignOut,
    onOpenAuth, // تابع باز کردن مودال ورود (می‌تواند mode بگیرد: 'login' یا 'signup')
    mobileMenuHidden,
    setMobileMenuHidden,
    Icons
}) => {

    const headerRef = useRef(null);
    const closeTimer = useRef(null);
    const R = useRef({});                 // رفرنس‌های SVG و گلو
    const widthRef = useRef(1280);        // عرض هدر
    const anim = useRef({                 // وضعیت فنر: موقعیت، سرعت و هدف
        cur: { cx: 0, w: 0, d: 0 },
        vel: { cx: 0, w: 0, d: 0 },
        tgt: { cx: 0, w: 0, d: 0 },
        raf: 0
    });

    const [tone, setTone] = useState('home');
    const [panelCenter, setPanelCenter] = useState(0);
    const [openMenu, setOpenMenu] = useState(null); // null | 'courses' | 'products'
    const [mobileCoursesOpen, setMobileCoursesOpen] = useState(false);
    const [mobileProductsOpen, setMobileProductsOpen] = useState(false);

    // رسم یک فریم: خطِ یک‌تکه با شکمِ بیرون‌زده + گرادیان‌ها + گلوی پشت آیتم
    const apply = () => {
        const r = R.current;
        if (!r.base) return;
        const { cur } = anim.current;
        const W = widthRef.current;
        const d = Math.max(0, cur.d);
        const w = Math.max(cur.w, 1);
        const cx = cur.cx;
        const x0 = cx - w / 2;
        const x1 = cx + w / 2;

        const line = d < 0.2
            ? `M0 0 L${W} 0`
            : `M0 0 L${x0} 0 C${x0 + 0.30 * w} 0 ${cx - 0.22 * w} ${d} ${cx} ${d} C${cx + 0.22 * w} ${d} ${x1 - 0.30 * w} 0 ${x1} 0 L${W} 0`;

        TONE_KEYS.forEach(t => {
            r['line_' + t]?.setAttribute('d', line);
            r['fill_' + t]?.setAttribute('d', line + ' Z');
            const gf = r['gFill_' + t];
            if (gf) { gf.setAttribute('x1', x0); gf.setAttribute('x2', x1); }
            const gh = r['gHl_' + t];
            if (gh) { gh.setAttribute('x1', cx - w * 0.9); gh.setAttribute('x2', cx + w * 0.9); }
        });
        r.base?.setAttribute('d', line);
        r.shell?.setAttribute('d', line + ' Z');

        if (r.glow) {
            r.glow.style.left = x0 + 'px';
            r.glow.style.width = w + 'px';
            r.glow.style.opacity = String(Math.min(1, d / BELLY_DEPTH));
        }
    };

    // انیمیشن فنری (کمی بالاروی تا شکم "جان" داشته باشد)
    const startAnim = () => {
        const a = anim.current;
        cancelAnimationFrame(a.raf);
        const tick = () => {
            let moving = false;
            ['cx', 'w', 'd'].forEach(k => {
                a.vel[k] += (a.tgt[k] - a.cur[k]) * 0.13;
                a.vel[k] *= 0.74;
                a.cur[k] += a.vel[k];
                if (Math.abs(a.vel[k]) > 0.01 || Math.abs(a.tgt[k] - a.cur[k]) > 0.05) moving = true;
            });
            apply();
            if (moving) a.raf = requestAnimationFrame(tick);
            else { a.cur = { ...a.tgt }; apply(); }
        };
        a.raf = requestAnimationFrame(tick);
    };

    // عرض هدر را دنبال کن تا خط همیشه کامل و یک‌تکه بماند
    useEffect(() => {
        const measure = () => {
            if (headerRef.current) widthRef.current = headerRef.current.clientWidth;
            apply();
        };
        measure();
        window.addEventListener('resize', measure);
        return () => {
            window.removeEventListener('resize', measure);
            cancelAnimationFrame(anim.current.raf);
        };
    }, []);

    // با تغییر صفحه، منوها بسته شوند
    useEffect(() => {
        setOpenMenu(null);
        anim.current.tgt.d = 0;
        startAnim();
    }, [activePage]);

    useEffect(() => () => clearTimeout(closeTimer.current), []);

    // اگر در صفحه ادمین هستیم، نوار نویگیشن را نمایش نده
    if (activePage === 'admin-panel') {
        return null;
    }

    // تابع کمکی برای هندل کردن نویگیشن و بستن منوی موبایل به صورت همزمان
    const handleNavClick = (page, section = null) => {
        onNavigate(page, section);
        setMobileMenuHidden(true); // بستن منوی موبایل بعد از کلیک
        setMobileCoursesOpen(false);
    };

    // شکم را زیر آیتم هاورشده ببر
    const moveBellyTo = (el, nextTone) => {
        if (!el || !headerRef.current) return;
        const h = headerRef.current.getBoundingClientRect();
        const r = el.getBoundingClientRect();
        const a = anim.current;
        const cx = r.left - h.left + r.width / 2;
        const w = r.width + 76;
        a.tgt = { cx, w, d: BELLY_DEPTH };
        // اگر شکم جمع بود، همان‌جا رشد کند (از جای قبلی نلغزد)
        if (a.cur.d < 0.5) {
            a.cur.cx = cx; a.cur.w = w;
            a.vel.cx = 0; a.vel.w = 0;
        }
        setTone(nextTone);
        startAnim();
    };

    const hideBelly = () => {
        anim.current.tgt.d = 0;
        startAnim();
    };

    const cancelClose = () => clearTimeout(closeTimer.current);

    const scheduleClose = () => {
        cancelClose();
        closeTimer.current = setTimeout(() => {
            setOpenMenu(null);
            hideBelly();
        }, 180);
    };

    // props مشترک هر آیتم دسکتاپ: هاور -> شکم متحرک با رنگ مخصوص
    const navItem = (toneKey, menu = null) => ({
        onMouseEnter: (e) => {
            cancelClose();
            moveBellyTo(e.currentTarget, toneKey);
            if (menu) {
                const h = headerRef.current.getBoundingClientRect();
                const r = e.currentTarget.getBoundingClientRect();
                setPanelCenter(r.left - h.left + r.width / 2);
            }
            setOpenMenu(menu);
        },
        onFocus: (e) => {
            moveBellyTo(e.currentTarget, toneKey);
            setOpenMenu(menu);
        },
        onMouseLeave: scheduleClose
    });

    const goCourse = (page) => {
        onNavigate(page);
        setOpenMenu(null);
        hideBelly();
    };

    const goNav = (page, section = null) => {
        onNavigate(page, section);
        setOpenMenu(null);
        hideBelly();
    };

    const coursesActive = COURSE_PAGES.includes(activePage);
    const productsActive = PRODUCT_PAGES.includes(activePage);

    // موقعیت پنل آموزش‌ها (وسط‌چین زیر دکمه و محدود به عرض صفحه)
    const PANEL_W = 460;
    const vw = typeof window !== 'undefined' ? window.innerWidth : 1280;
    const panelLeft = Math.min(Math.max(panelCenter - PANEL_W / 2, 12), Math.max(vw - PANEL_W - 12, 12));

    return (
      <header ref={headerRef} className="fixed w-full z-50 top-0 transition-all duration-300 glass-panel shadow-lg">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center relative z-10">
            {/* Logo */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => handleNavClick('home')}>
                <img 
                    src="https://arkaniomran.ir/images/Logo.png" 
                    alt="Logo" 
                    className="w-20 h-20 object-contain rounded-lg transform rotate-3 hover:rotate-0 transition-transform"
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                />
                <div>
                    <h1 className="text-xl font-bold tracking-tight text-white">ارکانی عمران</h1>
                    <span className="text-xs text-slate-400 block -mt-1 tracking-wider">Arkani Omran</span>
                </div>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden md:flex gap-4 lg:gap-6 text-xs lg:text-sm font-medium items-center">
                <button 
                    {...navItem('home')}
                    onClick={() => goNav('home')} 
                    className={`group flex items-center gap-1.5 hover:text-yellow-500 transition-colors ${activePage === 'home' ? 'text-yellow-500' : ''}`}
                >
                    <NavIcon name="home" tone="home" />
                    خانه
                </button>

                {/* منوی کشویی آموزش‌ها (جایگزین ۴ دکمه‌ی جداگانه) */}
                <button
                    {...navItem('courses', 'courses')}
                    onClick={() => setOpenMenu(o => (o === 'courses' ? null : 'courses'))}
                    aria-haspopup="true"
                    aria-expanded={openMenu === 'courses'}
                    className={`group flex items-center gap-1.5 transition-colors hover:text-yellow-400 ${coursesActive || openMenu === 'courses' ? 'text-yellow-400 font-bold' : ''}`}
                >
                    <NavIcon name="learn" tone="courses" />
                    آموزش‌ها
                    <span className={`transition-transform duration-300 ${openMenu === 'courses' ? 'rotate-180' : ''}`}>{CourseIcons.chevron}</span>
                    {/* نقطه‌ی چشمک‌زن برای دوره‌ی جدید */}
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500"></span>
                    </span>
                </button>

                <button 
                    {...navItem('free')}
                    onClick={() => goNav('free-apps')} 
                    className={`group flex items-center gap-1.5 hover:text-yellow-300 transition-colors border border-yellow-500/40 bg-yellow-500/5 hover:bg-yellow-500/10 px-3 py-1.5 rounded-lg shadow-[0_0_10px_rgba(234,179,8,0.2)] text-yellow-500`}
                >
                    <NavIcon name="free" tone="free" />
                    برنامه‌های رایگان
                </button>
                <button 
                    {...navItem('products', 'products')}
                    onClick={() => setOpenMenu(o => (o === 'products' ? null : 'products'))}
                    aria-haspopup="true"
                    aria-expanded={openMenu === 'products'}
                    className={`group flex items-center gap-1.5 hover:text-yellow-500 transition-colors ${productsActive || openMenu === 'products' ? 'text-yellow-500 font-bold' : ''}`}
                >
                    <NavIcon name="products" tone="products" />
                    محصولات
                    <span className={`transition-transform duration-300 ${openMenu === 'products' ? 'rotate-180' : ''}`}>{CourseIcons.chevron}</span>
                </button>
                <button 
                    {...navItem('forum')}
                    onClick={() => goNav('forum')} 
                    className={`hover:text-yellow-500 transition-colors group flex items-center gap-1.5 ${activePage === 'forum' ? 'text-yellow-500' : ''}`}
                >
                    <NavIcon name="forum" tone="forum" />
                    تالار گفت‌و‌گو
                </button>
                <button 
                    {...navItem('news')}
                    onClick={() => goNav('news')} 
                    className={`group flex items-center gap-1.5 hover:text-yellow-500 transition-colors ${activePage === 'news' ? 'text-yellow-500' : ''}`}
                >
                    <NavIcon name="news" tone="news" />
                    اخبار
                </button>
                <button 
                    {...navItem('about')}
                    onClick={() => goNav('about')} 
                    className={`group flex items-center gap-1.5 hover:text-yellow-500 transition-colors ${activePage === 'about' ? 'text-yellow-500' : ''}`}
                >
                    <NavIcon name="about" tone="about" />
                    درباره ما
                </button>
                
                {/* User Status / Login Button */}
                {user ? (
                   <div className="flex items-center gap-3 border-r border-slate-700 pr-4">
                      <div className="flex flex-col text-right">
                          <span className="text-yellow-500 text-xs font-bold truncate max-w-[100px]">
                              {userProfile?.username || 'کاربر'}
                          </span>
                          <button 
                              onClick={onSignOut} 
                              className="text-slate-400 text-[10px] hover:text-red-400 text-right"
                          >
                              خروج
                          </button>
                      </div>
                      <div className="w-8 h-8 rounded-full bg-slate-800 border border-yellow-500/50 flex items-center justify-center text-yellow-500">
                         <Icons.User size={16} />
                      </div>
                   </div>
                ) : (
                  <button 
                      onClick={() => onOpenAuth('login')} 
                      className="bg-yellow-500 text-slate-900 px-4 py-2 rounded-full font-bold hover:bg-yellow-400 transition-transform hover:scale-105"
                  >
                      ورود
                  </button>
                )}
            </nav>

            {/* Mobile Menu Button */}
            <button className="md:hidden text-white p-2" onClick={() => setMobileMenuHidden(!mobileMenuHidden)}>
                <Icons.Menu />
            </button>
        </div>

        {/* ===== گلوی گرادیانی پشت آیتم هاورشده (داخل هدر، فقط دسکتاپ) ===== */}
        <div
            aria-hidden="true"
            ref={el => (R.current.glow = el)}
            className="hidden md:block absolute top-0 bottom-0 pointer-events-none"
            style={{ left: 0, width: 0, opacity: 0 }}
        >
            {TONE_KEYS.map(t => (
                <div
                    key={t}
                    className="absolute inset-0 transition-opacity duration-300"
                    style={{
                        opacity: tone === t ? 1 : 0,
                        background: `radial-gradient(ellipse 80% 90% at 50% 100%, ${TONES[t].a}55 0%, ${TONES[t].b}30 45%, transparent 75%)`
                    }}
                />
            ))}
        </div>

        {/* ===== خط پایین هدر: یک‌تکه، با شکمِ بیرون‌زده زیر آیتم هاورشده (فقط دسکتاپ) ===== */}
        <svg
            aria-hidden="true"
            className="hidden md:block absolute left-0 pointer-events-none"
            style={{ top: '100%', width: '100%', height: BELLY_DEPTH + 14, overflow: 'visible', marginTop: -1 }}
        >
            <defs>
                {TONE_KEYS.map(t => (
                    <React.Fragment key={t}>
                        <linearGradient id={`hdr-fill-${t}`} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="1" y2="0" ref={el => (R.current['gFill_' + t] = el)}>
                            <stop offset="0%" stopColor={TONES[t].a} stopOpacity="0.55" />
                            <stop offset="55%" stopColor={TONES[t].b} stopOpacity="0.45" />
                            <stop offset="100%" stopColor={TONES[t].c} stopOpacity="0.35" />
                        </linearGradient>
                        <linearGradient id={`hdr-hl-${t}`} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="1" y2="0" ref={el => (R.current['gHl_' + t] = el)}>
                            <stop offset="0%" stopColor={TONES[t].a} stopOpacity="0" />
                            <stop offset="35%" stopColor={TONES[t].a} stopOpacity="1" />
                            <stop offset="65%" stopColor={TONES[t].b} stopOpacity="1" />
                            <stop offset="100%" stopColor={TONES[t].c} stopOpacity="0" />
                        </linearGradient>
                    </React.Fragment>
                ))}
            </defs>

            {/* بدنه‌ی شکم هم‌رنگ هدر (تا بیرون‌زدگی ادامه‌ی خود هدر دیده شود) */}
            <path ref={el => (R.current.shell = el)} d="M0 0 L1280 0" fill="rgba(15,23,42,0.94)" stroke="none" />

            {/* لایه‌ی رنگی گرادیانی؛ با تغییر آیتم، دو رنگ به‌نرمی جایگزین هم می‌شوند */}
            {TONE_KEYS.map(t => {
                return (
                    <path
                        key={t}
                        ref={el => (R.current['fill_' + t] = el)}
                        d="M0 0 L1280 0"
                        fill={`url(#hdr-fill-${t})`}
                        stroke="none"
                        style={{ opacity: tone === t ? 1 : 0, transition: 'opacity 300ms ease' }}
                    />
                );
            })}

            {/* خط پایه‌ی کامل و یک‌تکه */}
            <path ref={el => (R.current.base = el)} d="M0 0 L1280 0" fill="none" stroke="rgba(148,163,184,0.28)" strokeWidth="1" />

            {/* هایلایت درخشان روی خط، فقط اطراف شکم */}
            {TONE_KEYS.map(t => {
                return (
                    <path
                        key={t}
                        ref={el => (R.current['line_' + t] = el)}
                        d="M0 0 L1280 0"
                        fill="none"
                        stroke={`url(#hdr-hl-${t})`}
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        style={{ opacity: tone === t ? 1 : 0, transition: 'opacity 300ms ease', filter: `drop-shadow(0 0 4px ${TONES[t].a}aa)` }}
                    />
                );
            })}
        </svg>

        {/* ===== پنل‌های کشویی آموزش‌ها و محصولات (دسکتاپ) ===== */}
        {Object.entries(MENUS).map(([key, m]) => (
            <div
                key={key}
                onMouseEnter={cancelClose}
                onMouseLeave={scheduleClose}
                className={`hidden md:block absolute transition-all duration-300 ${openMenu === key ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-2 pointer-events-none'}`}
                style={{ top: `calc(100% + ${BELLY_DEPTH + 2}px)`, left: panelLeft, width: PANEL_W }}
            >
                {/* پل نامرئی تا موس هنگام پایین‌رفتن از آیتم به پنل، منو را نبندد */}
                <div className="absolute left-0 right-0 -top-8 h-8" />
                <div className="bg-slate-900/95 backdrop-blur-md border border-slate-700 rounded-2xl p-3 shadow-2xl shadow-black/40">
                    <div className="flex items-center justify-between px-2 pb-2 mb-2 border-b border-slate-800">
                        <span className="text-slate-300 text-xs font-bold">{m.title}</span>
                        <span className="text-slate-500 text-[10px]">{m.note}</span>
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        {m.items.map(c => (
                            <button
                                key={c.page}
                                onClick={() => goCourse(c.page)}
                                className={`group relative flex items-center gap-3 text-right p-2.5 rounded-xl border border-slate-800 transition-all duration-300 hover:-translate-y-0.5 ${c.hoverCard} ${c.wide ? 'col-span-2' : ''} ${activePage === c.page ? c.active : ''}`}
                            >
                                <span className={`shrink-0 w-11 h-11 rounded-xl border flex items-center justify-center transition-all duration-300 group-hover:scale-110 ${c.iconBox}`}>
                                    {CourseIcons[c.icon]}
                                </span>
                                <span className="flex flex-col min-w-0">
                                    <span className="text-white text-sm font-bold truncate">{c.title}</span>
                                    <span className="text-slate-400 text-[11px] truncate">{c.sub}</span>
                                </span>
                                {c.isNew && (
                                    <span className="absolute top-2 left-2 text-[10px] font-black px-2 py-0.5 rounded-full bg-cyan-500 text-slate-900 animate-pulse">
                                        جدید
                                    </span>
                                )}
                                {c.badge && (
                                    <span className={`absolute top-2 left-2 text-[10px] font-black px-2 py-0.5 rounded-full ${c.badgeCls || 'bg-yellow-500 text-slate-900'}`}>
                                        {c.badge}
                                    </span>
                                )}
                            </button>
                        ))}
                    </div>
                    {m.footer && (
                        <button
                            onClick={() => goNav(m.footer.page, m.footer.section)}
                            className="mt-2 w-full text-center text-xs font-bold text-slate-400 hover:text-yellow-400 py-2 rounded-xl border border-dashed border-slate-700 hover:border-yellow-500/50 transition-colors"
                        >
                            {m.footer.label} ←
                        </button>
                    )}
                </div>
            </div>
        ))}
        
        {/* Mobile Menu */}
        <div id="mobile-menu" className={`${mobileMenuHidden ? 'hidden' : ''} md:hidden bg-slate-900 border-t border-slate-800 p-4 absolute w-full left-0 shadow-xl z-40 max-h-[80vh] overflow-y-auto`}>
            <div className="flex flex-col gap-4 text-center">
                {user && (
                    <div className="bg-slate-800/50 p-3 rounded-lg flex items-center justify-between mb-2">
                         <div className="flex items-center gap-2">
                             <Icons.User size={18} className="text-yellow-500" />
                             <span className="text-white text-sm">{userProfile?.username || 'کاربر'}</span>
                         </div>
                         <button onClick={onSignOut} className="text-red-400 text-xs bg-red-500/10 px-2 py-1 rounded">خروج</button>
                    </div>
                )}
                
                <button onClick={() => handleNavClick('home')} className="group py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors flex items-center justify-center gap-2"><NavIcon name="home" tone="home" />خانه</button>

                {/* آموزش‌ها: آکاردئونی با آیکون برای هر دوره */}
                <div className="border-b border-slate-800 pb-2">
                    <button
                        onClick={() => setMobileCoursesOpen(o => !o)}
                        className="group w-full py-2 text-yellow-400 font-bold flex items-center justify-center gap-2"
                    >
                        <NavIcon name="learn" tone="courses" />
                        آموزش‌ها
                        <span className={`transition-transform duration-300 ${mobileCoursesOpen ? 'rotate-180' : ''}`}>{CourseIcons.chevron}</span>
                        <span className="relative flex h-2 w-2">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75"></span>
                          <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500"></span>
                        </span>
                    </button>
                    {mobileCoursesOpen && (
                        <div className="grid grid-cols-2 gap-2 mt-2">
                            {COURSES.map(c => (
                                <button
                                    key={c.page}
                                    onClick={() => handleNavClick(c.page)}
                                    className={`group relative flex flex-col items-center gap-1.5 p-3 rounded-xl border border-slate-800 bg-slate-800/40 ${c.wide ? 'col-span-2' : ''} ${activePage === c.page ? c.active : ''}`}
                                >
                                    <span className={`w-11 h-11 rounded-xl border flex items-center justify-center ${c.iconBox}`}>
                                        {CourseIcons[c.icon]}
                                    </span>
                                    <span className="text-white text-sm font-bold">{c.title}</span>
                                    <span className="text-slate-400 text-[11px]">{c.sub}</span>
                                    {c.isNew && (
                                        <span className="absolute top-2 left-2 text-[10px] font-black px-2 py-0.5 rounded-full bg-cyan-500 text-slate-900">جدید</span>
                                    )}
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                <button onClick={() => handleNavClick('free-apps')} className="group py-2 border-b border-slate-800 text-yellow-500 font-bold hover:bg-yellow-500/5 transition-colors flex items-center justify-center gap-2"><NavIcon name="free" tone="free" />برنامه‌های رایگان</button>
                {/* محصولات: آکاردئونی با آیکون برای هر محصول */}
                <div className="border-b border-slate-800 pb-2">
                    <button
                        onClick={() => setMobileProductsOpen(o => !o)}
                        className="group w-full py-2 hover:text-yellow-500 transition-colors flex items-center justify-center gap-2"
                    >
                        <NavIcon name="products" tone="products" />
                        محصولات
                        <span className={`transition-transform duration-300 ${mobileProductsOpen ? 'rotate-180' : ''}`}>{CourseIcons.chevron}</span>
                    </button>
                    {mobileProductsOpen && (
                        <div className="grid grid-cols-2 gap-2 mt-2">
                            {PRODUCTS.map(c => (
                                <button
                                    key={c.page}
                                    onClick={() => handleNavClick(c.page)}
                                    className={`group relative flex flex-col items-center gap-1.5 p-3 rounded-xl border border-slate-800 bg-slate-800/40 ${c.wide ? 'col-span-2' : ''} ${activePage === c.page ? c.active : ''}`}
                                >
                                    <span className={`w-11 h-11 rounded-xl border flex items-center justify-center ${c.iconBox}`}>
                                        {CourseIcons[c.icon]}
                                    </span>
                                    <span className="text-white text-sm font-bold">{c.title}</span>
                                    <span className="text-slate-400 text-[11px]">{c.sub}</span>
                                    {c.badge && (
                                        <span className={`absolute top-2 left-2 text-[10px] font-black px-2 py-0.5 rounded-full ${c.badgeCls || 'bg-yellow-500 text-slate-900'}`}>{c.badge}</span>
                                    )}
                                </button>
                            ))}
                            <button
                                onClick={() => handleNavClick('home', 'products-section')}
                                className="col-span-2 text-xs font-bold text-slate-400 py-2 rounded-xl border border-dashed border-slate-700"
                            >
                                مشاهده‌ی همه‌ی محصولات ←
                            </button>
                        </div>
                    )}
                </div>
                <button onClick={() => handleNavClick('forum')} className="group py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors flex items-center justify-center gap-2"><NavIcon name="forum" tone="forum" />تالار گفت‌و‌گو</button>
                <button onClick={() => handleNavClick('news')} className="group py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors flex items-center justify-center gap-2"><NavIcon name="news" tone="news" />اخبار</button>
                <button onClick={() => handleNavClick('about')} className="group py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors flex items-center justify-center gap-2"><NavIcon name="about" tone="about" />درباره ما</button>
                
                {!user && (
                    <button 
                        onClick={() => { onOpenAuth('login'); setMobileMenuHidden(true); }} 
                        className="text-yellow-500 py-2 font-bold hover:text-yellow-400 transition-colors border border-yellow-500/20 rounded-lg"
                    >
                        ورود / ثبت‌نام
                    </button>
                )}
            </div>
        </div>
      </header>
    );
};

export default HeaderNavigation;
